export const countUniqueArticleViewsOnSearchId = {
  analysisType: 'count_unique',
  eventCollection: 'kb.article.view',
  key: 'countUniqueArticleViewsOnSearchId',
  targetProperty: 'kb_referrer.search.id',
}
